import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface ScrollableFolderPathProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  contentClassName?: string;
}

/**
 * A single-line folder path that keeps each segment readable and scrolls when
 * the available width is narrower than the full path, while keeping the
 * scrollbar itself hidden.
 */
export function ScrollableFolderPath({
  children,
  className,
  contentClassName,
  ...props
}: ScrollableFolderPathProps) {
  return (
    <div
      className={cn(
        'min-w-0 overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden',
        className,
      )}
      {...props}
    >
      <div className={cn('flex w-max min-w-full items-center whitespace-nowrap pb-0.5', contentClassName)}>
        {children}
      </div>
    </div>
  );
}
